import { gql } from '@apollo/client'

export default gql`
  query GetBattleDemoPvESeasons($isGuild: Boolean!) {
    getDisplayableDungeonLeaderboardSchedules(forGuild: $isGuild) {
      isActive
      leaderboardKey
      metaKey
    }
  }
`
